// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__2re7_","footer":"ModalInfo_footer__1l1L4"};